import { useOperatorList } from '@services/operation'
import { Select, SelectProps } from '@shared/Form/Select'
import { useTranslation } from 'react-i18next'

type Props = SelectProps & {
  supportAll?: boolean
}

export const OperatorSelect = ({ supportAll = false, ...props }: Props) => {
  const { t } = useTranslation()

  const { data: operators = [] } = useOperatorList()

  return (
    <Select className="w-full" placeholder="選擇營運商" allowClear {...props}>
      {supportAll && (
        <Select.Option value={undefined}>{t('common:all')}</Select.Option>
      )}
      {operators.map(operator => (
        <Select.Option key={operator} value={operator}>
          {operator}
        </Select.Option>
      ))}
    </Select>
  )
}

export default OperatorSelect
